import {
  Container,
  Content,
  EventDate,
  EventDescription,
  EventNote,
  EventPeriod,
  Logo,
} from "./styles";

import LogoEvent from "../../../assets/clubmed/logo_clubmed_and_caioba.png";

const EventBannerClubMed = () => {
  return (
    <Container>
      <Content>
        <Logo alt="logo" loading="lazy" src={LogoEvent} />
        <EventDate>SETEMBRO DE 2025</EventDate>
        <EventPeriod>
          12 a 14 <span style={{ color: "#F3B000" }}>e</span> 19 a 21
        </EventPeriod>

        <EventDescription>
          O melhor fim de semana da sua família começa agora! Amarre as
          chuteiras, olho na bola e bora jogar!
        </EventDescription>
        <EventNote>
          *O Caioba Edição Club Med acontece em dois finais de semana, escolha a
          melhor data antes de seguir com a inscrição
        </EventNote>
      </Content>
    </Container>
  );
};

export default EventBannerClubMed;
